module.exports = __webpack_public_path__ + "img/title-books-m.72b36d8d.png";